import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IThirdNavCollapsibleElement } from '../common-page-components/third-nav-tab-component/third-nav-tab-component.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  /**
   * Property for check if we're in drupal and set the properly translation.
   *
   * @memberof AppComponent
   */
  isDrupal = false;

  selectedIndex = undefined;
  // tslint:disable-next-line:max-line-length
  /**
   * Rulebook routes for navigation
   *
   * @type {Array<IThirdNavCollapsibleElement>}
   * @memberof AppComponent
   */
  ruleBookRoutes: Array<IThirdNavCollapsibleElement> = [{route:'/rulebook', name:'Rulebook'},{route:'./interpretations', name:'Interpretations'}]
  showNav = false;
  title = 'Rulebook';
  constructor(router: Router) {
    if(window && window['Drupal']){
      this.isDrupal = true;
    }else{
      this.isDrupal = false;
    }
    router.events
      .pipe(filter(a => a instanceof NavigationStart))
      .subscribe((next: NavigationStart) => {
        switch (next.url) {
          case '/rulebook/interpretations':
            this.title = 'Interpretations';
            this.selectedIndex=1;
            break;
          default:
            this.title = 'Rulebook';
            this.selectedIndex=0;
        }
      });
  }
}
